/**
 * @file ppde页banner
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import classNames from 'classnames';

interface IBannerProps {
    className?: string;
}

const Banner: React.FC<IBannerProps> = (props) => {
    return (
        <div
            className={classNames(
                'paddle-banner-wrap',
                props.className
            )}
        >
            <div className="paddle-banner">
                <div className="paddle-banner-container">
                    <div className="paddle-banner-title" />
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default Banner;
